import PaidGrantPatternPage from './PaidGrantPatternPage';

export default PaidGrantPatternPage;
